import { render, staticRenderFns } from "./transport.vue?vue&type=template&id=71fb8f1c"
import script from "./transport.vue?vue&type=script&lang=ts"
export * from "./transport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports